export default __webpack_public_path__ + "static/media/pen.8bbfd32c.svg";